// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__c01ur"};